export const employeeManagementTableConfig = [
  {
    field: 'emp_no',
    header: 'SI.No',
    filter: false,
    visible: true,
    defaultPinned: true,
    sortable: false,
    order: 1,
    menuItems: [],
  },
  {
    field: 'full_name',
    header: 'Employee Name',
    filter: true,
    visible: true,
    defaultPinned: false,
    sortable: true,
    order: 2,
    menuItems: [],
  },
  {
    field: 'emp_id',
    header: 'Employee ID',
    filter: true,
    visible: true,
    defaultPinned: false,
    sortable: true,
    order: 3,
    menuItems: [],
  },
  {
    field: 'redmine_id',
    header: 'Redmine ID',
    filter: false,
    visible: true,
    defaultPinned: false,
    sortable: false,
    order: 4,
    menuItems: [],
  },
  {
    field: 'emp_type',
    header: 'Employment Type',
    filter: true,
    visible: true,
    defaultPinned: false,
    sortable: true,
    order: 5,
    menuItems: [],
  },
  {
    field: 'vertical',
    header: 'Vertical',
    filter: true,
    visible: true,
    defaultPinned: false,
    sortable: true,
    order: 6,
    menuItems: [],
  },
  {
    field: 'designation',
    header: 'Designation',
    filter: true,
    visible: true,
    defaultPinned: false,
    sortable: true,
    order: 7,
    menuItems: [],
  },
  {
    field: 'primary_skills',
    header: 'Pre Skills',
    filter: true,
    visible: true,
    defaultPinned: false,
    sortable: false,
    order: 9,
    menuItems: [],
  },
  {
    field: 'secondry_skills',
    header: 'Sec Skills',
    filter: true,
    visible: true,
    defaultPinned: false,
    sortable: false,
    order: 10,
    menuItems: [],
  },
  {
    field: 'joining_date',
    header: 'DOJ',
    filter: false,
    visible: true,
    defaultPinned: false,
    sortable: true,
    order: 11,
    menuItems: [],
  },
  {
    field: 'first_name',
    header: 'First Name',
    filter: true,
    visible: false,
    defaultPinned: false,
    sortable: true,
    order: 12,
    menuItems: [],
  },
  {
    field: 'experience_category',
    header: 'Experience Category',
    filter: true,
    visible: true,
    defaultPinned: false,
    sortable: true,
    order: 13,
    menuItems: [],
  },
  {
    field: 'location',
    header: 'Employee Location',
    filter: true,
    visible: true,
    defaultPinned: false,
    sortable: true,
    order: 14,
    menuItems: [],
  },
  {
    field: 'is_active',
    header: 'Status',
    filter: false,
    visible: true,
    defaultPinned: false,
    sortable: true,
    order: 15,
    menuItems: [],
  },
  {
    field: 'exit_date',
    header: 'Exit Date',
    filter: false,
    visible: true,
    defaultPinned: false,
    sortable: true,
    order: 16,
    menuItems: [],
    type: 'date',
  },
  {
    field: 'action',
    header: 'Action',
    width: 100,
    exportable: false,
    filter: false,
    visible: true,
    defaultPinned: false,
    sortable: false,
    order: 17,
    menuItems: [],
  },
];
